import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_SERVICE_CONFIG } from '@fullyops/legacy/data/index';
import { Observable } from 'rxjs';
import { AssetType, AssetTypeInput, ListedAssetType } from './asset-type';
import { ActionTypeLabel } from '../action-types/entities/action-type-entity';

@Injectable({ providedIn: 'root' })
export class ApiAssetTypesAdapterService {
  private http = inject(HttpClient);
  private config = inject(API_SERVICE_CONFIG);

  getAll(): Observable<ListedAssetType[]> {
    return this.http.get<ListedAssetType[]>(this.config.url + 'asset-types');
  }

  getAllByActionType(at: ActionTypeLabel): Observable<ListedAssetType[]> {
    const params = { allowsActionType: at };
    return this.http.get<ListedAssetType[]>(this.config.url + 'asset-types', {
      params,
    });
  }

  getById(id: string): Observable<AssetType> {
    return this.http.get<AssetType>(this.config.url + 'asset-types/' + id);
  }

  create(input: AssetTypeInput): Observable<{ id: string }> {
    return this.http.post<{ id: string }>(
      this.config.url + 'asset-types',
      input,
    );
  }

  update(id: string, input: AssetTypeInput): Observable<void> {
    return this.http.patch<void>(this.config.url + 'asset-types/' + id, input);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(this.config.url + 'asset-types/' + id);
  }
}
